<template>
  <modal 
    name="settled-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'640px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Updating client to Settled
      </div>

      <a href="#"
        @click.prevent="$modal.hide('settled-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body" v-if="client != null">
          
      <div class="text-base">
        Would you like to update the address for this client?
      </div>
      
      <div class="form-line flex items-center">
        <input type="radio" name="input-update-address" id="input-update-address-yes" v-model="updateClientAddress" :value="true" class="mr-2" />
        <label for="input-update-address-yes" class="text-sm mr-4">Yes</label>

        <input type="radio" name="input-update-address" id="input-update-address-no" v-model="updateClientAddress" :value="false" class="mr-2" />
        <label for="input-update-address-no" class="text-sm mr-4">No</label>
      </div>

      <div class="label-line text-base">
        Would you like to send an email to the client for a referral?
      </div>

      <div class="mt-1 text-sm text-gray-800">
        When a loan application settles, it's also the most likely time for your client to refer you to his/her friends &amp; colleagues.
        Select <span class="font-semibold">yes</span> and we will send an email to the client along with a link to your

        <router-link
          :to="{
            name  : 'broker-lead-capture',
            params: {
              brokerId : $store.state.brokerModule.broker.id
            }
          }"
          tag="a" class="font-semibold underline">Lead Capture Form</router-link>.
      </div>

      <div class="mt-3 flex items-center">
        <input type="radio" name="input-send-email" id="input-send-email-yes" v-model="sendEmail" :value="true" class="mr-2" />
        <label for="input-send-email-yes" class="text-sm mr-4">Yes</label>

        <input type="radio" name="input-send-email" id="input-send-email-no" v-model="sendEmail" :value="false" class="mr-2" />
        <label for="input-send-email-no" class="text-sm mr-4">No</label>
      </div>

      <div class="label-line text-base font-semibold">Message</div>

      <div class="form-line">
        <textarea
          class="w-full border border-gray-600 p-3 outline-none text-sm"
          style="height:150px;"
          v-model="message" />
      </div>

      <div class="button-line">
        <SubmitButton2 :onClick="close" :loading="loading" label="Submit" />
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        client             : null,
        loading            : false,
        clientStatus       : null,
        updateClientAddress: true,
        sendEmail          : true,
        message            : null,
        applicantId        : null,
      }
    },

    methods : {

      close() {        
        this.toggleSettled();
      },
      
      beforeOpen(event) {
        this.client              = event.params.client
        this.loading             = false
        this.clientStatus        = null
        this.updateClientAddress = true
        this.sendEmail           = true
        
        if(this.client.applicant_ids) {
          this.applicantId = this.client.applicant_ids.split(",")[0]
        }

        this.message = "Hi " + (this.client.applicants[0].firstName != '[None]' ? this.client.applicants[0].firstName : 'there') + 
                       ", this is " + this.$store.state.user.first_name + " " + this.$store.state.user.last_name + ".\r\n\r\n" + 
                       "Congratulations on getting your loan settled. It was a real pleasure helping you out throughout the process.\r\n\r\n" +
                       "I would love to help any of your friends or colleagues who are also looking for a similar service.\r\n\r\n" + 
                       "If you have anyone in mind, please feel free to forward the following link.\r\n\r\n" + 
                       this.getLeadCaptureUrl(this.$store.state.brokerModule.broker.id) + "\r\n\r\n" + 
                       "Once again, congratulations and if you have any questions or concerns, feel free to contact me at any time!\r\n" + 
                       "Cheers\r\n\r\n" + 
                       this.$store.state.user.first_name + " " + this.$store.state.user.last_name
      },

      opened(event) {

      },

      toggleSettled() {
        this.showLoader("Updating...")
        this.changeClientStatus(this.client.id, 1, (res) => {

          // send the email if true
          if(this.sendEmail) {
            this.apiPost({
              clientId: this.client.id,
              msg     : this.message,
            }, 'broker/ask-client-for-referral', (data) => {          

            })
          }

          if(this.updateClientAddress) {
            this.$router.push({ 
              name  : 'application-applicant-address', 
              params: {
                clientId   : this.client.id, 
                applicantId: this.applicantId
              }
            })
          }

          else {
            EventBus.$emit('fetch-clients')
            EventBus.$emit('get-num-clients-by-type')
            EventBus.$emit('notification-event', {
              type   : 'success',
              message: 'Client updated successfully.'
            });
            this.$modal.hide('settled-modal');
          }
        
        })
      }
    }
  }
</script>